export const blockIconsContentArchive = (
	<span className='material-symbols-outlined'>archive</span>
);
